import { api } from './api';
import {
  FinanceOverviewParams,
  FinanceOverviewResponse,
  FinanceLedgerParams,
  FinanceLedgerEntry,
  FinancePaymentsParams,
  FinancePaymentItem,
  FinancePayoutsParams,
  FinancePayoutItem,
  FinanceRefundsParams,
  FinanceRefundItem,
  FinanceCancellationsParams,
  FinanceCancellationsResponse,
  FinanceOperationsParams,
  FinanceOperationItem,
  FinancePaginatedResponse,
} from '../types/finance';

const BASE_PATH = '/admin/finance';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const cleanQueryParams = (params: any): Record<string, string | number> => {
  const clean: Record<string, string | number> = {};
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== '') {
      clean[key] = value as string | number;
    }
  }
  return clean;
};

export const getFinanceOverview = async (
  params: FinanceOverviewParams = {}
): Promise<FinanceOverviewResponse> => {
  const response = await api.get(`${BASE_PATH}/overview`, { params: cleanQueryParams(params) });
  return response.data;
};

export const getFinanceLedger = async (
  params: FinanceLedgerParams = {}
): Promise<FinancePaginatedResponse<FinanceLedgerEntry>> => {
  const response = await api.get(`${BASE_PATH}/ledger`, { params: cleanQueryParams(params) });
  return response.data;
};

export const getFinancePayments = async (
  params: FinancePaymentsParams = {}
): Promise<FinancePaginatedResponse<FinancePaymentItem>> => {
  const response = await api.get(`${BASE_PATH}/payments`, { params: cleanQueryParams(params) });
  return response.data;
};

export const getFinancePayouts = async (
  params: FinancePayoutsParams = {}
): Promise<FinancePaginatedResponse<FinancePayoutItem>> => {
  const response = await api.get(`${BASE_PATH}/payouts`, { params: cleanQueryParams(params) });
  return response.data;
};

export const getFinanceRefunds = async (
  params: FinanceRefundsParams = {}
): Promise<FinancePaginatedResponse<FinanceRefundItem>> => {
  const response = await api.get(`${BASE_PATH}/refunds`, { params: cleanQueryParams(params) });
  return response.data;
};

export const getFinanceCancellations = async (
  params: FinanceCancellationsParams = {}
): Promise<FinanceCancellationsResponse> => {
  const response = await api.get(`${BASE_PATH}/cancellations`, { params: cleanQueryParams(params) });
  return response.data;
};

export const getFinanceOperations = async (
  params: FinanceOperationsParams = {}
): Promise<FinancePaginatedResponse<FinanceOperationItem>> => {
  const response = await api.get(`${BASE_PATH}/operations`, { params: cleanQueryParams(params) });
  return response.data;
};

export const financeService = {
  getFinanceOverview,
  getFinanceLedger,
  getFinancePayments,
  getFinancePayouts,
  getFinanceRefunds,
  getFinanceCancellations,
  getFinanceOperations,
};

export default financeService;
